//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export class BaseEntity {
    identifier : string;
    createdOn : string ;
    modifiedOn : string ;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.modifiedOn = null;
        }
}

export class AppConfiguration extends BaseEntity {
    shop : ShopConfiguration;
    adminEmail : string;
    helpEmail : string;
    daysOfSubscriptionTolerance : number;
    smtpMailConfig : SmtpMailConfiguration;
    urlConfiguration : UrlConfiguration;
    privacyDocument : Attachment;
    termsAndConditions : Attachment;
    googleMapsApiKey : string;

    constructor() 
    {
    	        super();
		            this.shop = new ShopConfiguration();
                this.adminEmail = "" ;
                this.helpEmail = "" ;
                this.daysOfSubscriptionTolerance = null ;
                this.smtpMailConfig = new SmtpMailConfiguration();
                this.urlConfiguration = new UrlConfiguration();
                this.privacyDocument = new Attachment();
                this.termsAndConditions = new Attachment();
                this.googleMapsApiKey = "" ;
        }
}

export class ShopConfiguration {
    materials : PrintMaterial[];
    shippingOptions : ShippingOption[];

    constructor() 
    {
    	            this.materials = [];
                this.shippingOptions = [];
        }
}

export class PrintMaterial {
    identifier : string;
    name : string;
    description : string;
    pricePerUnit : number;
    isActive : boolean;

    constructor() 
    {
    	            this.identifier = "" ;
                this.name = "" ;
                this.description = "" ;
                this.pricePerUnit = null ;
                this.isActive = false ;
        }
}

export class ShippingOption {
    identifier : string;
    name : string;
    description : string;
    price : number;
    estimatedDays : string;
    isActive : boolean;

    constructor() 
    {
    	            this.identifier = "" ;
                this.name = "" ;
                this.description = "" ;
                this.price = null ;
                this.estimatedDays = "" ;
                this.isActive = false ;
        }
}

export class SmtpMailConfiguration {
    server : string;
    port : number;
    username : string;
    password : string;
    defaultSenderEmail : string;
    defaultSenderName : string;

    constructor() 
    {
    	            this.server = "" ;
                this.port = null ;
                this.username = "" ;
                this.password = "" ;
                this.defaultSenderEmail = "" ;
                this.defaultSenderName = "" ;
        }
}

export class UrlConfiguration {
    apiUrl : string;
    webAppUrl : string;
    siteUrl : string;

    constructor() 
    {
    	            this.apiUrl = "" ;
                this.webAppUrl = "" ;
                this.siteUrl = "" ;
        }
}

export class Attachment {
    identifier : string;
    filename : string;
    path : string;
    mimeType : string;
    publicUrl : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.filename = "" ;
                this.path = "" ;
                this.mimeType = "" ;
                this.publicUrl = "" ;
        }
}

export class Commessa extends BaseEntity {
    enabled : boolean;
    name : string;
    isDefault : boolean;
    logo : Attachment;
    owner : NameIdentifier;
    enabledUsers : CommessaUserEntry[];
    activeQrLimit : number;
    generatedQrLimit : number;

    constructor() 
    {
    	        super();
		            this.enabled = false ;
                this.name = "" ;
                this.isDefault = false ;
                this.logo = new Attachment();
                this.owner = new NameIdentifier();
                this.enabledUsers = [];
                this.activeQrLimit = null ;
                this.generatedQrLimit = null ;
        }
}

export class NameIdentifier {
    name : string;
    identifier : string;

    constructor() 
    {
    	            this.name = "" ;
                this.identifier = "" ;
        }
}

export class CommessaUserEntry {
    user : NameIdentifier;
    role : string;

    constructor() 
    {
    	            this.user = new NameIdentifier();
                this.role = "" ;
        }
}

export class CommessaAvailableAllowances {
    activeQrLimit : number;
    generatedQrLimit : number;

    constructor() 
    {
    	            this.activeQrLimit = null ;
                this.generatedQrLimit = null ;
        }
}

export class CommessaSummaryVm {
    identifier : string;
    ownerIdentifier : string;
    createdOn : string ;
    name : string;
    companyName : string;
    isSubscriptionActive : boolean;
    enabled : boolean;
    isDefault : boolean;
    logo : Attachment;
    activeQrLimit : number;
    generatedQrLimit : number;

    constructor() 
    {
    	            this.identifier = "" ;
                this.ownerIdentifier = "" ;
                this.createdOn = null;
                this.name = "" ;
                this.companyName = "" ;
                this.isSubscriptionActive = false ;
                this.enabled = false ;
                this.isDefault = false ;
                this.logo = new Attachment();
                this.activeQrLimit = null ;
                this.generatedQrLimit = null ;
        }
}

export class BaseCommessaEntity extends BaseEntity {
    commessaIdentifier : string;

    constructor() 
    {
    	        super();
		            this.commessaIdentifier = "" ;
        }
}

export class ExcelQrMapping extends BaseCommessaEntity {
    name : string;
    mappingDefinitions : MappingDefinition[];

    constructor() 
    {
    	        super();
		            this.name = "" ;
                this.mappingDefinitions = [];
        }
}

export class MappingDefinition {
    columnNumber : number;
    fieldName : string;
    actionType : string;

    constructor() 
    {
    	            this.columnNumber = null ;
                this.fieldName = "" ;
                this.actionType = "" ;
        }
}

export class PlacePredictionVm {
    placeId : string;
    description : string;

    constructor() 
    {
    	            this.placeId = "" ;
                this.description = "" ;
        }
}

export class Address {
    typedAddress : string;
    city : string;
    province : string;
    postalCode : string;
    addressDetails : string;
    street : string;
    streetNumber : string;
    notes : string;
    country : string;
    region : string;
    latLong : LatLng;
    completeAddress : string;

    constructor() 
    {
    	            this.typedAddress = "" ;
                this.city = "" ;
                this.province = "" ;
                this.postalCode = "" ;
                this.addressDetails = "" ;
                this.street = "" ;
                this.streetNumber = "" ;
                this.notes = "" ;
                this.country = "" ;
                this.region = "" ;
                this.latLong = new LatLng();
                this.completeAddress = "" ;
        }
}

export class LatLng {
    lat : number;
    lng : number;

    constructor() 
    {
    	            this.lat = null ;
                this.lng = null ;
        }
}

export class LoginVm {
    username : string;
    password : string;
    registerInvitationToken : string;

    constructor() 
    {
    	            this.username = "" ;
                this.password = "" ;
                this.registerInvitationToken = "" ;
        }
}

export class ResetPasswordVm {
    email : string;
    password : string;
    token : string;

    constructor() 
    {
    	            this.email = "" ;
                this.password = "" ;
                this.token = "" ;
        }
}

export class MailEventDefinition {
    eventName : string;
    variables : string[];

    constructor() 
    {
    	            this.eventName = "" ;
                this.variables = [];
        }
}

export class MailEventDefinitionWithDesc extends MailEventDefinition {
    description : string;

    constructor() 
    {
    	        super();
		            this.description = "" ;
        }
}

export class OrderApprovalRequest extends BaseCommessaEntity {
    shopOrderIdentifier : string;
    sentBy : NameIdentifier;
    processedBy : NameIdentifier;
    senderNote : string;
    adminNote : string;
    approvalResult : StatusHistoryItem;

    constructor() 
    {
    	        super();
		            this.shopOrderIdentifier = "" ;
                this.sentBy = new NameIdentifier();
                this.processedBy = new NameIdentifier();
                this.senderNote = "" ;
                this.adminNote = "" ;
                this.approvalResult = new StatusHistoryItem();
        }
}

export class StatusHistoryItem {
    status : string;
    changedOn : string ;
    notes : string;

    constructor() 
    {
    	            this.status = "" ;
                this.changedOn = null;
                this.notes = "" ;
        }
}

export class ProcessOrderRequestVm {
    approvalRequestIdentifier : string;
    notes : string;
    result : string;

    constructor() 
    {
    	            this.approvalRequestIdentifier = "" ;
                this.notes = "" ;
                this.result = "" ;
        }
}

export class PdfInterpolationDocument extends BaseEntity {
    name : string;
    documentType : string;
    originalPdf : Attachment;
    pageScreenshots : Attachment[];
    pageWidth : number;
    pageHeight : number;
    stickDataConfigs : BaseStickDataConfig[];
    isActive : boolean;

    constructor() 
    {
    	        super();
		            this.name = "" ;
                this.documentType = "" ;
                this.originalPdf = new Attachment();
                this.pageScreenshots = [];
                this.pageWidth = null ;
                this.pageHeight = null ;
                this.stickDataConfigs = [];
                this.isActive = false ;
        }
}

export abstract class BaseStickDataConfig {
    x : number;
    y : number;
    pageNumber : number;
    type : string;

    constructor() 
    {
    	            this.x = null ;
                this.y = null ;
                this.pageNumber = null ;
                this.type = "" ;
        }
}

export class TextDataConfig extends BaseStickDataConfig {
    text : string;
    fontSize : number;
    fontFamily : string;
    color : string;
    fontWeight : string;
    textAlign : string;

    constructor() 
    {
    	        super();
		            this.text = "" ;
                this.fontSize = null ;
                this.fontFamily = "" ;
                this.color = "" ;
                this.fontWeight = "" ;
                this.textAlign = "" ;
        }
}

export class ImageDataConfig extends BaseStickDataConfig {
    image : Attachment;
    objectFit : string;
    width : number;
    height : number;

    constructor() 
    {
    	        super();
		            this.image = new Attachment();
                this.objectFit = "" ;
                this.width = null ;
                this.height = null ;
        }
}

export class DocumentFieldConfig extends BaseStickDataConfig {
    fieldName : string;
    fontSize : number;
    fontFamily : string;
    color : string;
    fontWeight : string;
    textAlign : string;

    constructor() 
    {
    	        super();
		            this.fieldName = "" ;
                this.fontSize = null ;
                this.fontFamily = "" ;
                this.color = "" ;
                this.fontWeight = "" ;
                this.textAlign = "" ;
        }
}

export class PrintTemplate extends BaseCommessaEntity {
    name : string;
    createdBy : NameIdentifier;
    modifiedBy : NameIdentifier;
    width : number;
    height : number;
    borderRadius : string;
    backgroundColor : string;
    isActive : boolean;
    components : PrintTemplateComponent[];

    constructor() 
    {
    	        super();
		            this.name = "" ;
                this.createdBy = new NameIdentifier();
                this.modifiedBy = new NameIdentifier();
                this.width = null ;
                this.height = null ;
                this.borderRadius = "" ;
                this.backgroundColor = "" ;
                this.isActive = false ;
                this.components = [];
        }
}

export abstract class PrintTemplateComponent {
    x : number;
    y : number;
    zIndex : number;
    type : string;

    constructor() 
    {
    	            this.x = null ;
                this.y = null ;
                this.zIndex = null ;
                this.type = "" ;
        }
}

export class TextComponent extends PrintTemplateComponent {
    text : string;
    fontSize : number;
    fontFamily : string;
    color : string;
    fontWeight : string;
    textAlign : string;
    width : number;
    height : number;

    constructor() 
    {
    	        super();
		            this.text = "" ;
                this.fontSize = null ;
                this.fontFamily = "" ;
                this.color = "" ;
                this.fontWeight = "" ;
                this.textAlign = "" ;
                this.width = null ;
                this.height = null ;
        }
}

export class ImageComponent extends PrintTemplateComponent {
    image : Attachment;
    objectFit : string;
    width : number;
    height : number;

    constructor() 
    {
    	        super();
		            this.image = new Attachment();
                this.objectFit = "" ;
                this.width = null ;
                this.height = null ;
        }
}

export class QrCodeComponent extends PrintTemplateComponent {
    size : number;
    showQrName : boolean;

    constructor() 
    {
    	        super();
		            this.size = null ;
                this.showQrName = false ;
        }
}

export class QrFieldComponent extends PrintTemplateComponent {
    fieldType : string;
    fontSize : number;
    fontFamily : string;
    color : string;
    fontWeight : string;
    textAlign : string;
    width : number;
    height : number;

    constructor() 
    {
    	        super();
		            this.fieldType = "" ;
                this.fontSize = null ;
                this.fontFamily = "" ;
                this.color = "" ;
                this.fontWeight = "" ;
                this.textAlign = "" ;
                this.width = null ;
                this.height = null ;
        }
}

export class TablePagedResultOfPrintTemplate {
    data : PrintTemplate[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class BaseListFilterVm {
    paginationData : PaginationData;

    constructor() 
    {
    	            this.paginationData = new PaginationData();
        }
}

export class PrintTemplateListFilterVm extends BaseListFilterVm {
    name : string;
    commessaIdentifier : string;
    isActive : boolean;
    createdBy : string;
    modifiedBy : string;

    constructor() 
    {
    	        super();
		            this.name = "" ;
                this.commessaIdentifier = "" ;
                this.isActive = false ;
                this.createdBy = "" ;
                this.modifiedBy = "" ;
        }
}

export class PaginationData {
    pageNumber : number;
    perPage : number;
    sortBy : SortByParameter;

    constructor() 
    {
    	            this.pageNumber = null ;
                this.perPage = null ;
                this.sortBy = new SortByParameter();
        }
}

export class SortByParameter {
    propertyName : string;
    ascending : boolean;

    constructor() 
    {
    	            this.propertyName = "" ;
                this.ascending = false ;
        }
}

export class ProgramSubscriptionDetailVm {
    identifier : string;
    code : string;
    licenseType : string;
    allowances : Allowances;
    startsOn : string ;
    endsOn : string ;
    attachments : Attachment[];

    constructor() 
    {
    	            this.identifier = "" ;
                this.code = "" ;
                this.licenseType = "" ;
                this.allowances = new Allowances();
                this.startsOn = null;
                this.endsOn = null;
                this.attachments = [];
        }
}

export class Allowances {
    maxCommesse : number;
    activeQrLimit : number;
    generatedQrLimit : number;

    constructor() 
    {
    	            this.maxCommesse = null ;
                this.activeQrLimit = null ;
                this.generatedQrLimit = null ;
        }
}

export class ProgramSubscription extends BaseEntity {
    code : string;
    owner : NameIdentifier;
    allowances : Allowances;
    startsOn : string ;
    endsOn : string ;
    pricePaid : number;
    attachments : Attachment[];
    comments : Comment[];
    licenseType : string;

    constructor() 
    {
    	        super();
		            this.code = "" ;
                this.owner = new NameIdentifier();
                this.allowances = new Allowances();
                this.startsOn = null;
                this.endsOn = null;
                this.pricePaid = null ;
                this.attachments = [];
                this.comments = [];
                this.licenseType = "" ;
        }
}

export class Comment {
    identifier : string;
    createdOn : string ;
    author : NameIdentifier;
    text : string;
    attachments : Attachment[];

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.author = new NameIdentifier();
                this.text = "" ;
                this.attachments = [];
        }
}

export class SaveCommentVm {
    entityIdentifier : string;
    comment : Comment;

    constructor() 
    {
    	            this.entityIdentifier = "" ;
                this.comment = new Comment();
        }
}

export class QrConfig extends BaseCommessaEntity {
    name : string;
    description : string;
    info : string;
    note : string;
    createdBy : NameIdentifier;
    modifiedBy : NameIdentifier;
    redirectToUrl : string;
    isActive : boolean;
    defaultTemplate : NameIdentifier;
    isAuthRequired : boolean;
    authType : string;
    authPassword : string;

    constructor() 
    {
    	        super();
		            this.name = "" ;
                this.description = "" ;
                this.info = "" ;
                this.note = "" ;
                this.createdBy = new NameIdentifier();
                this.modifiedBy = new NameIdentifier();
                this.redirectToUrl = "" ;
                this.isActive = false ;
                this.defaultTemplate = new NameIdentifier();
                this.isAuthRequired = false ;
                this.authType = "" ;
                this.authPassword = "" ;
        }
}

export class TablePagedResultOfQrConfig {
    data : QrConfig[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class QrConfigListFilterVm extends BaseListFilterVm {
    name : string;
    description : string;
    info : string;
    note : string;
    createdBy : string;
    modifiedBy : string;
    isActive : boolean;
    commessaIdentifier : string;

    constructor() 
    {
    	        super();
		            this.name = "" ;
                this.description = "" ;
                this.info = "" ;
                this.note = "" ;
                this.createdBy = "" ;
                this.modifiedBy = "" ;
                this.isActive = false ;
                this.commessaIdentifier = "" ;
        }
}

export class QrUsageCounterVm {
    activeQrNumber : number;
    activeQrLimit : number;
    generatedQrNumber : number;
    generatedQrLimit : number;

    constructor() 
    {
    	            this.activeQrNumber = null ;
                this.activeQrLimit = null ;
                this.generatedQrNumber = null ;
                this.generatedQrLimit = null ;
        }
}

export class QrConfigForOrderVm {
    qr : NameIdentifier;
    defaultTemplate : NameIdentifier;

    constructor() 
    {
    	            this.qr = new NameIdentifier();
                this.defaultTemplate = new NameIdentifier();
        }
}

export class QrPrintRequest extends BaseCommessaEntity {
    token : string;
    qrIdentifiers : string[];
    user : NameIdentifier;
    useSpecificTemplate : boolean;
    templateIdentifier : string;
    usedOn : string ;
    totalCount : number;
    processedCount : number;
    exportFileId : string;
    completedOn : string ;
    downloadedOn : string ;

    constructor() 
    {
    	        super();
		            this.token = "" ;
                this.qrIdentifiers = [];
                this.user = new NameIdentifier();
                this.useSpecificTemplate = false ;
                this.templateIdentifier = "" ;
                this.usedOn = null;
                this.totalCount = null ;
                this.processedCount = null ;
                this.exportFileId = "" ;
                this.completedOn = null;
                this.downloadedOn = null;
        }
}

export class QrPrintProgressVm {
    identifier : string;
    processedCount : number;
    totalCount : number;
    isCompleted : boolean;

    constructor() 
    {
    	            this.identifier = "" ;
                this.processedCount = null ;
                this.totalCount = null ;
                this.isCompleted = false ;
        }
}

export class SendRegisterInvitationVm {
    email : string;
    commessaIdentifier : string;
    role : string;

    constructor() 
    {
    	            this.email = "" ;
                this.commessaIdentifier = "" ;
                this.role = "" ;
        }
}

export class RegisterInvitation extends BaseEntity {
    invitedEmail : string;
    registrationToken : string;
    commessa : NameIdentifier;
    roleInCommessa : string;
    usedOn : string ;
    expiresOn : string ;

    constructor() 
    {
    	        super();
		            this.invitedEmail = "" ;
                this.registrationToken = "" ;
                this.commessa = new NameIdentifier();
                this.roleInCommessa = "" ;
                this.usedOn = null;
                this.expiresOn = null;
        }
}

export class CompleteRegisterInvitationVm {
    registrationToken : string;
    username : string;
    password : string;

    constructor() 
    {
    	            this.registrationToken = "" ;
                this.username = "" ;
                this.password = "" ;
        }
}

export class QrAuthVm {
    identifier : string;
    password : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.password = "" ;
        }
}

export class QrAuthLoginVm {
    identifier : string;
    username : string;
    password : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.username = "" ;
                this.password = "" ;
        }
}

export class ShopCategoryConfig extends BaseEntity {
    name : string;
    description : string;
    image : Attachment;

    constructor() 
    {
    	        super();
		            this.name = "" ;
                this.description = "" ;
                this.image = new Attachment();
        }
}

export class ShopOrder extends BaseCommessaEntity {
    qrPrintItems : QrPrintItem[];
    shopProducts : ShopProductQuantity[];
    shippingAddress : Address;
    shippingOption : NameIdentifier;
    shippingPrice : number;
    finalPrice : number;
    statusHistory : StatusHistoryItem[];
    notes : string;

    constructor() 
    {
    	        super();
		            this.qrPrintItems = [];
                this.shopProducts = [];
                this.shippingAddress = new Address();
                this.shippingOption = new NameIdentifier();
                this.shippingPrice = null ;
                this.finalPrice = null ;
                this.statusHistory = [];
                this.notes = "" ;
        }
}

export class QrPrintItem {
    identifier : string;
    qrConfig : NameIdentifier;
    template : NameIdentifier;
    material : NameIdentifier;
    materialUnitPrice : number;
    quantity : number;

    constructor() 
    {
    	            this.identifier = "" ;
                this.qrConfig = new NameIdentifier();
                this.template = new NameIdentifier();
                this.material = new NameIdentifier();
                this.materialUnitPrice = null ;
                this.quantity = null ;
        }
}

export class ShopProductQuantity {
    product : NameIdentifier;
    quantity : number;

    constructor() 
    {
    	            this.product = new NameIdentifier();
                this.quantity = null ;
        }
}

export class AddProductToOrderVm {
    isQrPrint : boolean;
    existingOrderIdentifier : string;
    productIdentifier : string;
    quantity : number;

    constructor() 
    {
    	            this.isQrPrint = false ;
                this.existingOrderIdentifier = "" ;
                this.productIdentifier = "" ;
                this.quantity = null ;
        }
}

export class TablePagedResultOfShopOrderForListVm {
    data : ShopOrderForListVm[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class ShopOrderForListVm {
    identifier : string;
    createdOn : string ;
    status : string;
    commessa : NameIdentifier;
    user : NameIdentifier;
    qrCount : number;
    articoliCount : number;
    notes : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.status = "" ;
                this.commessa = new NameIdentifier();
                this.user = new NameIdentifier();
                this.qrCount = null ;
                this.articoliCount = null ;
                this.notes = "" ;
        }
}

export class ShopOrderListFilterVm extends BaseListFilterVm {
    commessaIdentifier : string;
    status : string;
    notes : string;

    constructor() 
    {
    	        super();
		            this.commessaIdentifier = "" ;
                this.status = "" ;
                this.notes = "" ;
        }
}

export class SubmitOrderVm {
    orderIdentifier : string;
    notes : string;

    constructor() 
    {
    	            this.orderIdentifier = "" ;
                this.notes = "" ;
        }
}

export class ShopProduct extends BaseEntity {
    name : string;
    description : string;
    categoryIdentifier : string;
    image : Attachment;
    technicalSheet : Attachment;
    unitPrice : number;

    constructor() 
    {
    	        super();
		            this.name = "" ;
                this.description = "" ;
                this.categoryIdentifier = "" ;
                this.image = new Attachment();
                this.technicalSheet = new Attachment();
                this.unitPrice = null ;
        }
}

export class SubscriptionType extends BaseEntity {
    order : number;
    name : string;
    description : string;
    isVisible : boolean;
    isTrial : boolean;
    allowances : Allowances;
    durationInDays : number;
    price : number;

    constructor() 
    {
    	        super();
		            this.order = null ;
                this.name = "" ;
                this.description = "" ;
                this.isVisible = false ;
                this.isTrial = false ;
                this.allowances = new Allowances();
                this.durationInDays = null ;
                this.price = null ;
        }
}

export class User extends BaseEntity {
    role : string;
    authData : AuthData;
    personalData : PersonalData;
    billingInfo : BillingInfo;
    comments : Comment[];

    constructor() 
    {
    	        super();
		            this.role = "" ;
                this.authData = new AuthData();
                this.personalData = new PersonalData();
                this.billingInfo = new BillingInfo();
                this.comments = [];
        }
}

export class AuthData {
    username : string;
    password : string;
    tokenForResetPassword : string;

    constructor() 
    {
    	            this.username = "" ;
                this.password = "" ;
                this.tokenForResetPassword = "" ;
        }
}

export class PersonalData {
    name : string;
    surname : string;
    companyName : string;
    fullname : string;

    constructor() 
    {
    	            this.name = "" ;
                this.surname = "" ;
                this.companyName = "" ;
                this.fullname = "" ;
        }
}

export class BillingInfo {
    companyName : string;
    vatNumber : string;
    sdiCode : string;
    email : string;
    telephone : string;
    pec : string;
    address : Address;

    constructor() 
    {
    	            this.companyName = "" ;
                this.vatNumber = "" ;
                this.sdiCode = "" ;
                this.email = "" ;
                this.telephone = "" ;
                this.pec = "" ;
                this.address = new Address();
        }
}

export class TablePagedResultOfUserForListVm {
    data : UserForListVm[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class UserForListVm {
    createdOn : string ;
    identifier : string;
    name : string;
    username : string;
    role : string;
    commessaRoleList : CommessaRoleVm[];

    constructor() 
    {
    	            this.createdOn = null;
                this.identifier = "" ;
                this.name = "" ;
                this.username = "" ;
                this.role = "" ;
                this.commessaRoleList = [];
        }
}

export class CommessaRoleVm {
    name : string;
    role : string;

    constructor() 
    {
    	            this.name = "" ;
                this.role = "" ;
        }
}

export class UserListFilterVm extends BaseListFilterVm {
    search : string;

    constructor() 
    {
    	        super();
		            this.search = "" ;
        }
}

export class InterpolationTemplate extends BaseEntity {
    subject : LocalizedValue;
    text : LocalizedValue;
    defaultLanguage : string;
    useRawHtmlEditor : boolean;
    eventName : string;
    additionalCc : string[];
    additionalBcc : string[];

    constructor() 
    {
    	        super();
		            this.subject = new LocalizedValue();
                this.text = new LocalizedValue();
                this.defaultLanguage = "" ;
                this.useRawHtmlEditor = false ;
                this.eventName = "" ;
                this.additionalCc = [];
                this.additionalBcc = [];
        }
}

export class LocalizedValue {
    values : { [key: string]: string; };

    constructor() 
    {
    	            this.values = {};
        }
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}